import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LogoStore {

}

export enum LogoStoreKeys {

}
